import SkillStamps from '../SkillStamps';
interface ScoreCardHeaderProps {
  performanceType: string;
  judgesInitials: string;
  entry: string;
  routine: string;
  program: string;
  danceStyle: string;
  performance_performers: JSON;
  program_skills_abhs: number;
  program_skills_abhs_mod2: number;
  program_skills_pom_straps: number;
}

const ScoreCardHeader: React.FC<ScoreCardHeaderProps> = ({
  performanceType,
  judgesInitials,
  entry,
  routine,
  program,
  danceStyle,
  performance_performers,
  program_skills_abhs,
  program_skills_abhs_mod2,
  program_skills_pom_straps,
}) => {
  return (
    <div className="w-layout-blockcontainer w-container">
      {performanceType === "sds" ? (
        <div className="w-layout-blockcontainer w-container">
          <div
            id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af0-38e776aa"
            className="w-layout-layout quick-stack-5 wf-layout-layout"
          >
            <div
              id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af1-38e776aa"
              className="w-layout-cell"
            >
              <p
                className="paragraph-6 flex"
                style={{ textTransform: "capitalize" }}
              >
                <strong>Judges Initials:&nbsp;</strong> {judgesInitials}
              </p>
            </div>
            <div
              id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af2-38e776aa"
              className="w-layout-cell"
            >
              <p className="paragraph-6 flex">
                <strong>Entry #:&nbsp;</strong> {entry} 
              </p>
              </div>
              <div
              id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af2-38e776aa"
              className="w-layout-cell">
              <p className="paragraph-6 flex">
                {performance_performers && Array.isArray(performance_performers) ? (
                  <div>
                    {performance_performers.map((performer, rowindex: number) => (
                      <span key={performer.id}>
                        {performer.user?.first_name} {performer.user?.last_name}
                        { (rowindex+1) !== performance_performers.length ? ", " : null}
                      </span>
                    ))}
                  <SkillStamps result={{ program_skills_abhs, program_skills_abhs_mod2, program_skills_pom_straps }} />
                  </div>
                ) : (
                  null
                )}
              </p>
            </div>  
          </div>          
        </div>
      ) : (
        <div className="w-layout-blockcontainer w-container">
          <div
            id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af0-755489e6"
            className="w-layout-layout quick-stack-5 wf-layout-layout"
          >
            <div
              id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af1-755489e6"
              className="w-layout-cell"
            >
              <p
                className="paragraph-6"
                style={{ textTransform: "capitalize" }}
              >
                <strong>Judges Initials:&nbsp;</strong> {judgesInitials}
              </p>
            </div>
            <div
              id="w-node-_9db2a870-6351-e6bf-fd16-c354c3873af2-755489e6"
              className="w-layout-cell"
            >
              <p className="paragraph-6">
                <strong>Routine #:&nbsp;</strong> {routine}
              </p>
            </div>
            <div
              id="w-node-_004ccc9b-4f68-1aa0-8dba-7cc56ff5aac7-755489e6"
              className="w-layout-cell"
            >
                <p className="paragraph-6">
                <strong>Program:&nbsp;</strong> {program}
            </p>
                <SkillStamps result={{ program_skills_abhs, program_skills_abhs_mod2, program_skills_pom_straps }} />
            </div>
            <div
              id="w-node-_58b52bf1-e13a-9bf6-6dc9-779e6203c082-755489e6"
              className="w-layout-cell"
            >
              <p className="paragraph-6">
                <strong>Style:&nbsp;</strong> {danceStyle}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreCardHeader;
